"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIGGER_TRANSITION = '@ui-router/TRIGGER_TRANSITION';
exports.START_TRANSITION = '@ui-router/START_TRANSITION';
exports.IGNORED_TRANSITION = '@ui-router/IGNORED_TRANSITION';
exports.REDIRECTED_TRANSITION = '@ui-router/REDIRECTED_TRANSITION';
exports.FINISH_TRANSITION = '@ui-router/FINISH_TRANSITION';
exports.SUCCESS_TRANSITION = '@ui-router/SUCCESS_TRANSITION';
exports.triggerTransition = function (to, params) {
    return {
        type: exports.TRIGGER_TRANSITION,
        to: to,
        params: params,
    };
};
//# sourceMappingURL=actions.js.map